import { BASE } from '@arcxgame/contracts'
import { CoreCapsuleWithAccount, PoolCapsuleWithAccount } from 'entities'
import { BigNumber } from 'ethers'
import { bigDiv, scaleValue } from 'utils'
import { IFutureValues, NULL_FUTURE_VALUES } from './IFutureValues'

export function getBorrowFutureValues(
  coreCapsule: CoreCapsuleWithAccount,
  poolCapsule: PoolCapsuleWithAccount,
  borrowAsset: { address: string; decimals: number },
  inputAmount: BigNumber,
): IFutureValues {
  const {
    accountProperties: {
      borrowedAmountScaled,
      maxLTV,
      collateralAmount,
      collateralValue: collateralDollars,
    },
    collateralDecimals,
  } = coreCapsule

  const scaledInput = scaleValue(inputAmount, borrowAsset.decimals)
  const maxBorrow = coreCapsule.getAccountMaxBorrowAmount(
    poolCapsule,
    borrowAsset.address,
    undefined,
    inputAmount,
  )

  let futureMaxBorrow = maxBorrow
  if (futureMaxBorrow.isNegative()) {
    futureMaxBorrow = BigNumber.from(0)
  }

  if (futureMaxBorrow.gt(maxBorrow)) {
    // This is because inputAmount could be negative
    futureMaxBorrow = maxBorrow
  }

  const userMinCRatio = BASE.mul(BASE).div(maxLTV)
  const collateralAmountScaled = scaleValue(collateralAmount, collateralDecimals)
  const newBorrowedDollars = borrowedAmountScaled.add(scaledInput)
  let futureLiquidationPrice = BigNumber.from(0)
  let futureLTV = null
  if (newBorrowedDollars.gt(0) && collateralAmountScaled.gt(0)) {
    futureLiquidationPrice = userMinCRatio.mul(newBorrowedDollars).div(collateralAmountScaled)
    futureLTV = bigDiv(newBorrowedDollars, collateralDollars)
  }

  return {
    ...NULL_FUTURE_VALUES,
    futureBorrowed: borrowedAmountScaled.add(scaledInput),
    futureAvailable: scaleValue(futureMaxBorrow, borrowAsset.decimals),
    futureLiquidationPrice,
    futureLTV,
  }
}
